export enum CompanyResources {
    SetupGuideInitialActionComplete = '/v2/companyManagement/setupGuides/:setupGuideId/initialActionComplete',
    SetupGuideFinalActionComplete = '/v2/companyManagement/setupGuides/:setupGuideId/finalActionComplete',
    SetupGuideStepComplete = '/v2/companyManagement/setupGuideSteps/:setupGuideStepId/stepComplete',
}
